import React, { useState, useEffect } from 'react';
import { contactAPI } from 'services/apisService';

const UserListDropdown = ({ 
  usersDropdownRef, 
  setShowUsersDropdown, 
  showUsersDropdown, 
  selectedUserId, 
  handleUserSelect, 
  clearUserFilter,
  apiType = 'contact' 
}) => {
  const [usersData, setUsersData] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setUserName(user?.role);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (usersDropdownRef.current && !usersDropdownRef.current.contains(event.target)) {
        setShowUsersDropdown(false);
      }
    };

    if (showUsersDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUsersDropdown, usersDropdownRef, setShowUsersDropdown]);

  const fetchUsersList = async () => {
    if (userName !== 'ADMIN') return;
    
    try {
    setUsersLoading(true);
    const response = await contactAPI.getUsers();
    setUsersData(response.data || []);
  } catch (err) {
    console.error("Failed to fetch users list:", err);
  } finally {
    setUsersLoading(false);
  }
  };

  useEffect(() => {
    if (userName === 'ADMIN') {
      fetchUsersList();
    }
  }, [userName, apiType]);

  if (userName !== 'ADMIN') {
    return null;
  }

  return (
    <div className={`flex items-start gap-2 ${apiType === 'contact' ? 'pr-4' : 'pr-0'}`}>
      <div className="relative" ref={usersDropdownRef}>
        <button
          onClick={() => setShowUsersDropdown(!showUsersDropdown)}
          className="flex items-center justify-between min-w-48 px-4 py-2 border-2 border-green-200 rounded-lg bg-gradient-to-r from-green-50 to-green-100 hover:from-green-100 hover:to-green-200 focus:outline-none focus:ring-2 focus:ring-green-300 transition-all duration-200 shadow-sm"
        >
          <span className="text-gray-700 font-medium">
            {selectedUserId ? (() => {
              const selectedUser = usersData.find(u => u.id === selectedUserId);
              return `${selectedUser?.name}`;
            })() : "User's List"}
          </span>
          <svg
            className={`w-5 h-5 transition-transform duration-200 ${showUsersDropdown ? 'transform rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {showUsersDropdown && (
          <div className="absolute top-full left-0 mt-2 w-[210px] bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden">
            {usersLoading ? (
              <div className="px-4 py-3 text-center">
                <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-green-500 mx-auto"></div>
              </div>
            ) : usersData.length > 0 ? (
              <>
                {usersData.map((user, index) => (
                  <button
                    key={user.id}
                    onClick={() => handleUserSelect(user)}
                    className="w-full text-left px-4 py-3 hover:bg-gradient-to-r hover:from-green-50 hover:to-green-100 focus:outline-none transition-all duration-150 border-b border-gray-100 last:border-b-0"
                  >
                    <span className="font-medium text-gray-700">{user.name}</span>
                  </button>
                ))}
              </>
            ) : (
              <div className="px-4 py-3 text-gray-500 text-center">No users found</div>
            )}
          </div>
        )}
      </div>

      {selectedUserId && (
        <button
          onClick={clearUserFilter}
          className="p-2 mt-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full transition-all duration-200 shadow-sm"
          title="Clear user filter"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default UserListDropdown;